import { render } from "./Create.vue?vue&type=template&id=593a7b7e"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Logistics/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "593a7b7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('593a7b7e', __exports__)) {
    console.log('reload')
    api.reload('593a7b7e', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=593a7b7e", () => {
    console.log('re-render')
    api.rerender('593a7b7e', render)
  })

}


export default __exports__